import React, { useContext } from 'react';
import styles from './ProjectCardDetailsList.module.scss';
import {
  ProjectCounters,
  ProjectRow
} from '../../../../../../../../Models/ProjectValue';
import { MediaContext } from 'ui-smartforce-settings';
import { MobileProjectTable } from './MobileProjectTable/MobileProjectTable';
import { ProjectTable } from './ProjectTable/ProjectTable';

export const PROJECT_REPORTS_LIMIT = 1000;

export interface ProjectCardDetailsListProps {
  className?: string;
  counters: ProjectCounters;
  rows: ProjectRow[];
  onSeeDateRowReports: (index: number) => void;
}

export const ProjectCardDetailsList = ({
  className = '',
  counters,
  rows,
  onSeeDateRowReports
}: ProjectCardDetailsListProps): React.ReactElement<ProjectCardDetailsListProps> => {
  const { isPhone } = useContext(MediaContext);

  return (
    <div className={`${styles.projectCardDetailsList} ${className}`}>
      {isPhone && (
        <MobileProjectTable
          counters={counters}
          rows={rows}
          onSeeDateRowReports={onSeeDateRowReports}
        />
      )}
      {!isPhone && (
        <ProjectTable
          counters={counters}
          rows={rows}
          onSeeDateRowReports={onSeeDateRowReports}
        />
      )}
    </div>
  );
};
